<mat-form-field style="width: 100%">
    <mat-label>{{ isLoading ? "Lädt..." : label }}</mat-label>
    <mat-select
        [disabled]="isLoading"
        #select
        [formControl]="selectCtrl"
        (selectionChange)="setSelectedOption($event)"
        [compareWith]="comparator"
    >
        <mat-option [ngClass]="multiLine ? 'multiline-mat-option' : ''" *ngFor="let o of options" [value]="o">{{
            formatOptionText(o)
        }}</mat-option>
    </mat-select>
    <mat-error *ngIf="selectCtrl.hasError('required')">{{ label }} ist ein Pflichtfeld.</mat-error>
</mat-form-field>
